import request from '@/request/index'
import { getNewsList as mockGetNewsList } from '@/mock/news'
import { getProductList as mockGetProductList } from '@/mock/products'

// 使用 mock 数据
const useMock = true

// 产品列表
export const fetchProductList = () => {
  if (useMock) {
    return mockGetProductList()
  }
  return request.get('/products/list', {}, {
    showLoading: true,
    showError: true
  })
}

//首页banner资源
export function getBanner(params) {
  return request.get('/anon/banner', params)
}

//首页产品与解决方案 pcenter/solutions
export function getProductSolutions(params) {
  return request.get('/pcenter/solutions', params)
}

// 获取友情链接数据
export function getFootLink(params) {
  return request.get('/anon/link', params)
}

//行业解决方案数据 pcenter/solution/1945746764644442114
export function getProductSolutionDetail(solutionId) {
  return request.get(`/pcenter/solution/${solutionId}`)
}


//获取领先工艺数据 /anon/innovations?type=1
export function getInnovations(params) {
  return request.get('/anon/innovations', params, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

//质量管理数据 /anon/qualities
export function getQualities(params) {
  return request.get('/anon/qualities', params, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

//获取产品与解决方案的页面数据 pcenter/solutions
export function getProductSolutionPage(params) {
  return request.get('/pcenter/solutions', params)
}

//全局搜索
export function getPageSearch(params) {
  return request.get('/pcenter/search', params )
}

/**
 * 提交表单
 * @type {string} integer - 表单类型
 * @returns {Promise} 返回字典数据
 */
export function submitProductForm(data) {
  return request.post('/anon/chat', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

/**
 * 获取字典表数据
 * @param {string} code - 字典编码
 * @returns {Promise} 返回字典数据
 */
export function getDictByCode(code) {
  return request.get(`/anon/code/${code}`, {}, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 导出 news 模块的接口
export * from './news'
// 导出 products 模块的接口
export * from './products'
// ... 其他导出 